import Vue from 'vue';
import firebase from 'firebase';
import App from './App.vue';
import router from './router';
import 'bootstrap-icons/font/bootstrap-icons';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

import VueMeta from 'vue-meta'
import Notifications from 'vue-notification'

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faJs, faVuejs } from '@fortawesome/free-brands-svg-icons';
library.add(faCoffee, faJs, faVuejs);

import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
 
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.use(Notifications)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false;

let app = '';
const config = {
  apiKey: "AIzaSyDe_912VaH0GvtC6zuCSl3cVaRmqVV0uMc",
  authDomain: "oforis-3f704.firebaseapp.com",
  databaseURL: "https://oforis-3f704.firebaseio.com",
  projectId: "oforis-3f704",
  storageBucket: "oforis-3f704.appspot.com",
  messagingSenderId: "642963845930",
  appId: "1:642963845930:web:1c21c9f52b22394c29a453"
};

firebase.initializeApp(config);
export const auth = firebase.auth();
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
export default firebase;
export const db = firebase.database();
export const firestore = firebase.firestore();
Vue.prototype.$db = db;
Vue.prototype.$firestore = firestore;
export const firestorage = firebase.storage();

//import VueAnalytics from 'vue-analytics';
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-EC8Y5WT4VL" },
  appName: 'Oforis',
  pageTrackerScreenviewEnabled: true
}, router);
/*
Vue.use(VueAnalytics, {
  id: 'G-ZVM8ZFKJ4D',
  disabled: false,
  router
});*/
firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app');
  }
});
